import React, { Component } from "react";
import styled from "styled-components";
import HeartIcon from "react-icons/lib/fa/heartbeat";
import { Helmet } from "react-helmet";

import { Container } from "reactstrap";

class AuthTemplate extends Component {
  render() {
    const { title, children } = this.props;
    return (
      <StyledContainer>
        <Helmet>
          <title>{title} | OpiekujSię.pl</title>
        </Helmet>
        <Panel>
          <StyledHeartIcon size="40" />
          <Title>{title}</Title>
          {children}
        </Panel>
      </StyledContainer>
    );
  }
}

const StyledContainer = styled(Container)`
  @media (max-width: 575px) {
    padding: 0px;
  }
`;

const Panel = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.04);
  border-width: 0;
  border-radius: 2px;
  border-color: #ddd;
  margin: 40px auto;
  max-width: 600px;
  padding: 50px 10px;

  @media (max-width: 991px) {
    margin: 0px auto;
  }
`;
const StyledHeartIcon = styled(HeartIcon)`color: #ea4335;`;

const Title = styled.div.attrs({
  className: "text-dark"
})`
  font-size: 20px;
  font-weight: 300;
`;

export default AuthTemplate;



// WEBPACK FOOTER //
// ./src/auth/AuthTemplate.js